import { Component, Input } from '@angular/core';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';

import { BusinessServices } from './../../businesses/services/business.services';

@Component({
    selector: 'control-messages',
    template: `@if (
    errorMessage !== null && control && (control.dirty || control.touched)
  ) {
    <div class="error-msg">
      {{ errorMessage | translate }}
    </div>
  }`,
  standalone: false
})
export class ValidationMessagesComponent {
    @Input() control: any;
    @Input() result: any;
    OrganizationNumber: string;
    constructor(private businessServices: BusinessServices) {}

    get errorMessage() {
        if (this.control) {
            for (let propertyName in this.control.errors) {
                // Username-uniqueness errors are displayed by each form's own
                // inline "already taken by an active user" message.
                if (
                    propertyName === 'invalidUserName' ||
                    propertyName === 'invalidUserNameWithId'
                ) {
                    continue;
                }
                if (
                    (this.control.errors.hasOwnProperty(propertyName) &&
                        (this.control.touched ||
                            propertyName ===
                                'startDateLessThanEqualToEndDate' ||
                            propertyName === 'startDateLessThanCurrentDate' ||
                            propertyName === 'websiteValidator' ||
                            propertyName === 'numberValidator' ||
                            propertyName === 'mobileNumberValidator' ||
                            propertyName === 'startDateEndDateYearCheck')) ||
                    propertyName ===
                        'deadLineDaysLessThanEqualToFollowupDays' ||
                    propertyName === 'multipleCheckboxRequireOne' ||
                    propertyName === 'deadlineValidation' ||
                    propertyName === 'nomatch'
                ) {
                    return ValidationService.getValidatorErrorMessage(
                        propertyName,
                        this.control.errors[propertyName]
                    );
                } else {
                    return null;
                }
            }
        }
    }
}
